import React from 'react';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import './Portrait.css';

import HomePage from './pages/Home';
import DirectoryPage from './pages/Directory';
import ContactPage from './pages/Contacts';
import InformationsPage from './pages/Information';

import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Nav from './components/nav';
import { RootState } from './store';
import PageWrapper from './PageWrapper';

export type ParamsType = {
    buildingid: string;
};

function App() {
    const dispatch = useDispatch();
    const { Accessibility } = useSelector((state: RootState) => state.access);
    const { buildingId } = useParams();

    return Accessibility === 'ON' ? (
        <div className="Body">
            <Router>
                <Nav />
                <div className="Main">
                    <div className="MainContent">
                        <Routes>
                            <Route
                                path="/:buildingId"
                                element={
                                    <PageWrapper>
                                        <HomePage />
                                    </PageWrapper>
                                }
                            />
                            <Route
                                path="/Directory/:buildingId"
                                element={
                                    <PageWrapper>
                                        <DirectoryPage />
                                    </PageWrapper>
                                }
                            />
                            <Route
                                path="/Contacts/:buildingId"
                                element={
                                    <PageWrapper>
                                        <ContactPage />
                                    </PageWrapper>
                                }
                            />
                            <Route
                                path="/Informations/:buildingId"
                                element={
                                    <PageWrapper>
                                        <InformationsPage />
                                    </PageWrapper>
                                }
                            />
                        </Routes>
                    </div>
                    <Header />
                    <Footer />
                </div>
            </Router>
        </div>
    ) : (
        <div className="Body">
            <Router>
                <Nav />
                <div className="Main">
                    <Header />
                    <div className="MainContent">
                        <Routes>
                            <Route
                                path="/:buildingId"
                                element={
                                    <PageWrapper>
                                        <HomePage />
                                    </PageWrapper>
                                }
                            />
                            <Route
                                path="/Directory/:buildingId"
                                element={
                                    <PageWrapper>
                                        <DirectoryPage />
                                    </PageWrapper>
                                }
                            />
                            <Route
                                path="/Contacts/:buildingId"
                                element={
                                    <PageWrapper>
                                        <ContactPage />
                                    </PageWrapper>
                                }
                            />
                            <Route
                                path="/Informations/:buildingId"
                                element={
                                    <PageWrapper>
                                        <InformationsPage />
                                    </PageWrapper>
                                }
                            />
                        </Routes>
                    </div>
                    <Footer />
                </div>
            </Router>
        </div>
    );
}

export default App;
